import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { fetcher } from '../../client'
import { requestTemplate, deleteRequestTemplate } from '../../actions/templates'

export function useRequestCustomTemplate(options = {}) {
  const { t } = useTranslation(['common']);
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(requestTemplate(payload)), {
    ...options,
    onSuccess: (payload, variables) => {
      if (options.onSuccess) options.onSuccess(payload, variables)
      queryClient.invalidateQueries('requested-templates');
      queryClient.invalidateQueries('profile')
      toast.success(t('successMessages.templateUploaded'))
    },
    onError: (err) => {
      toast.error(t('errorMessages.templateUploaded'), {
          toastId: 'requestTemplateError'
      })
    }
  });
}

export function useDeleteRequestCustomTemplate(options = {}) {
  const { t } = useTranslation(['common']);
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(deleteRequestTemplate(payload)), {
    ...options,
    onSuccess: (payload, variables) => {
      if (options.onSuccess) options.onSuccess(payload, variables)
      queryClient.invalidateQueries('requested-templates');
      queryClient.invalidateQueries('profile')
    },
    onError: (err) => {
      // toast.error(t('errorMessages.templateUploaded'), {
      //     toastId: 'requestTemplateError'
      // })
    }
  });
}